.details-list {
    margin-top: 12px;
}

.details-list > * {
    margin-bottom: 12px;
}
